module.exports = __webpack_public_path__ + "img/settings-app.eb7decfa.svg";